import * as types from "../../types/API/gateEntry";
export const getGateEntriesById = (payload : any) => {
  return {
    type: types.GET_GATE_ENTRIES_BY_ID,
    payload: payload,
  };
}

export const getAllGateEntries = (payload : any) => {
  return {
    type: types.GET_ALL_GATE_ENTRIES,
    payload: payload,
  };
}

export const updateGateEntry = (payload : any) => {
  return {
    type: types.UPDATE_GATE_ENTRY,
    payload: payload,
  };
}

export const createGateEntry = (payload : any) => {
  return {
    type: types.CREATE_GATE_ENTRY,
    payload: payload,
  };
} 